import { View360 } from './View360';

export type { TypeView360Props } from './types';
export default View360;
